import * as React from "react";
import Spinner from "components/common/Spinner";
import ReportingWidget from "report/common/ReportingWidget";
import useWidgetResult from "report/hooks/useWidgetResult";
const ReportingWidgetPreview = ({ dashboardId, widgetId, parameterValues, widget, height, width, ...rest }) => {
  const { data: value, isLoading, isError, error } = useWidgetResult({ dashboardId, widgetId, parameterValues });
  if (isError) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, "Error while fetching widget:"), " ", /* @__PURE__ */ React.createElement("p", null, JSON.stringify(error, null, 2)));
  }
  return isLoading ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(ReportingWidget, { ...rest, widget, value, height, width });
};
export default ReportingWidgetPreview;
